/**
 * Action type constants for active-deals Redux slice.
 * Shared by dashboard and admin-portal.
 */
export const SET_DEAL_DATA = "SET_DEAL_DATA";
export const SET_DEAL_SORT_ORDER = "SET_DEAL_SORT_ORDER";
export const SET_DEAL_RESET_SORT = "SET_DEAL_RESET_SORT";
